import React from 'react';
import PropTypes from 'prop-types';
import Pikaday from 'pikaday';
import moment from 'moment';
import { Input } from './styles';

class PikadayReact extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // eslint-disable-next-line
    const format = this.props.dateFormat || 'YYYY-MM-DD';
    if (this.picker) {
      this.pikaday = new Pikaday({
        field: this.picker,
        format,
        onSelect: (value) => {
          this.props.onChange(moment(value).format(format));
        },
        ...this.props.pikadayConfig,
      });

      // const d = new Date((this.props.value + "T00:00:00").replace(/-/g, '\/').replace(/T.+/, ''));
      const d = new Date((this.props.value).replace(/-/g, '\/').replace(/T.+/, ''));

      // this.pikaday.setDate(this.props.value);
      this.pikaday.setDate(d);
    }
  }

  render() {
    const { disabled, value } = this.props;
    if (this.pikaday && disabled && value === '') {
      this.pikaday.setDate(value);
    }
    // return input.form-control(id=id type="text" name=name data-toggle="datepicker" readonly)
    return (
      <Input
        readOnly
        ref={(node) => {
          this.picker = node;
        }}
        disabled={disabled}
        type="text"
      />
    );
  }
}

PikadayReact.defaultProps = {
  value: '',
};

export default PikadayReact;
